<div id="iframe-container">
  <iframe
    (load)="onLoadEvent()"
    #iframe
    id="hickory-frame"
    class="hickory"
    [src]="hickoryUrl"
    title="Content from Legacy App"></iframe>
  @if (isLoading) {
    <app-loading [isCircle]="false"></app-loading>
  }
</div>
